import React, { Component } from 'react';
import '../../../styles/variables.css';
import database from '../../../firebase/firebase';
import {NotificationContainer} from 'react-notifications';

class Applicants extends Component {
    state = {
        applicants: [],
        showDetails: false,
        currentUser: {}
    }

    componentDidMount(){
        if(this.props.match.params.id === undefined){
            this.props.history.goBack();
        }else {
            database.collection(`companies/${this.props.match.params.owner}/jobs/${this.props.match.params.id}/applicants/`)
            .get().then(s => {
                s.forEach((doc) => {
                    this.setState(prevState => ({
                        applicants: [...prevState.applicants, doc.data()]
                    }))
                 })
            }).catch(e => {
                console.log(e)
            })
        }
    }

    seeAll = (user) =>{
        this.setState({
            showDetails: true,
            currentUser: user
        })
    }

    render(){
        return(
            <div className="b-container">
                <p className="app-text"> Aplicantes a esta vacante </p>
                <div className="b-card-applicants">
                    {this.state.applicants.map((user) => {
                        return <div key={user.id} className="b-list-element" onClick={() => { this.seeAll(user)} }>
                            <p className="b-a-name">{user.name}</p>
                        </div>
                    })}
                </div>
                <div className="b-card-applicant">
                    {this.state.showDetails ? 
                    <div className="b-d-a-info">
                        <p className="user-info">{this.state.currentUser.name}</p>
                        <p className="user-info">{this.state.currentUser.phoneNumber}</p>
                        <p className="user-info">{this.state.currentUser.email}</p>
                        <p className="user-info">{this.state.currentUser.career}</p>
                        <p className="user-info">{this.state.currentUser.expertise}</p>
                        <p className="user-info">{this.state.currentUser.locationName}</p>
                        <a href={this.state.currentUser.cv} target="_blank" className="user-info mx-auto d-block">Descargar Cv</a>
                    </div>
                    :null}
                </div>
                <NotificationContainer />
            </div>
        )
    }
}

export default Applicants;